import userActions from './loginActions'

const allActions = {
    userActions
}

export default allActions